module.exports = __webpack_public_path__ + "static/media/Group 20.1b3699f5.png";